import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { Stack, Box, Divider, Chip } from '@mui/material'
import { MarkdownEditor } from '@ui/forms'
import CropMarginFields from '../../../../../CropMarginFields'

interface Props {
  onCropConfigChange: (config: {
    croppedLeft: number
    croppedTop: number
    croppedRight: number
    croppedBottom: number
  }) => void
}

const FormFields = ({ onCropConfigChange }: Props) => {
  const bu = useWatch({ name: 'bu' })
  const bb = useWatch({ name: 'bb' })
  const bl = useWatch({ name: 'bl' })
  const br = useWatch({ name: 'br' })

  useEffect(() => {
    onCropConfigChange({
      croppedLeft: bl,
      croppedTop: bu,
      croppedRight: br,
      croppedBottom: bb,
    })
  }, [bu, bl, br, bb])

  const file = useWatch({ name: 'file' })
  const { setValue } = useFormContext()

  return (
    <Stack direction="column" spacing={2}>
      {file && (
        <Box>
          <Chip
            label={file.name}
            onDelete={() => {
              setValue('file', null)
            }}
            color="primary"
            variant="outlined"
          />
        </Box>
      )}

      <MarkdownEditor
        name="preamble"
        label="Vorbemerkungen"
        placeholder="Vorbemerkungen (mehrere Zeilen möglich)"
        allowHorizontalResize={false}
      />

      <Divider />

      <CropMarginFields />
    </Stack>
  )
}

export default FormFields
